<template>
  <!--产品技术页面-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="itemData.imgBoxUrl" class="el-image__inner">
      </div>
      <!--      <div class="imgText">
              <div>产品介绍</div>
              <div>YAG激光治疗仪YAG激光治疗仪YAG激光治疗仪YAG</div>
            </div>-->
    </div>
    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in itemData.numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>
    <!--    内容-->
    <div class="contentBox" v-for="item in itemData.productData"  v-show="item.showData">
      <div class="contentTitle">
        {{item.text1}}
      </div>
      <div class="contentImg">
        <div class="leftImg">
<!--          <el-image
            style="width: 578px; height: 700px"
            :src="product1.img1"
            :fit="contain"></el-image>-->
          <img :src="item.img1" alt="" class="imgoo">
        </div>
        <div class="rightImg">
          <div class="rightTopImg">

<!--            <el-image
              style="width: 578px; height: 340px"
              :src="product1.img2"
              :fit="contain"></el-image>-->
            <img :src="item.img2" alt="" class="imgoo">
          </div>
          <div class="rightBottomImg">
<!--            <el-image
              style="width: 578px; height: 340px"
              :src="product1.img3"
              :fit="contain"></el-image>-->
            <div class="rightBottomImg_1">
              <img :src="item.img3" alt="" class="imgoo">
            </div>
          </div>
        </div>

      </div>
      <div class="contentDetail">
        <div class="itemTitle">{{item.text2}}</div>
        <el-divider></el-divider>
        <div class="itemContent">
          {{item.text3}}
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import Mun2 from "./image/mun2";
import {Data} from "./js/product";
export default {
  name: "product",
  components: {Mun2},
  data() {
    return {
      urlData:"",
      numIndex: "1",
      dataAll: Data,
      itemData: {},
    }
  },
  mounted() {
    let that = this;
    console.log("init");
    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }
    that.init();
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'cpjs')
      } else {
        let index = "1";
        if(that.urlData == 'cpjs'){
          index = "1";
        } else if (that.urlData == 'gzj'){
          index = "2";
        } else if (that.urlData == 'sb'){
          index = "3";
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      for(let indexNum in that.itemData.productData){
        let item = that.itemData.productData[indexNum];
        if(index == item.num){
          item.showData = true;
        } else {
          item.showData = false;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.contentTitle{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
}
.productPage {
  display: block;
  width: 100%;
  background-color: #FFFFFF;
}

.imgBox {
  width: 100%;
  aspect-ratio: 1920/600;
}

.imageItem {
  height: 100%;
}

.menuBox {
  width: 100%;
  height: 60px;
  background: #F3F4F8;
}

.contentBox {
  width: 61.25%;
  /*height: 700px;*/
  margin: 50px auto;
}

.contentImg {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
  aspect-ratio: 1176/700;
  display: flex;
}
.leftImg{
  border-radius: 10px;
  width: 49.15%;
}


.rightImg{
  width: 50.85%;
}
.imgoo{
  width: 100%;
  height: 100%;
  border-radius: 10px;

}
.rightTopImg{
  border-radius: 10px;

  width: 96.66%;
  margin-left: auto;
  height: 48.66%;


}

.rightBottomImg{
  border-radius: 10px;

  width: 96.66%;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  height: 51.34%;
}
.rightBottomImg_1{
  width: 100%;
  margin-top: auto;
}

.img1 {
  width: 100%;
  border-radius: 10px;
}

.itemTitle {
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
  height: 50px;
}

.itemContent {
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
}

</style>



// WEBPACK FOOTER //
// src/components/product.vue